var render = function render(){var _vm=this,_c=_vm._self._c;return _c('printPage',{staticClass:"body",attrs:{"printForm":_vm.postForm}})
}
var staticRenderFns = []

export { render, staticRenderFns }